<template>
  <div>
    <div v-if="searchData && searchData.type === 'star_summary'">
      <div class="star-home-top">
        <StarHead />
      </div>
      <div
        v-for="(item, index) in starEntity.entity || []"
        :key="index"
      >
        <div v-show="starTab === item.doctype">
          <ClassList
            v-if="['film', 'teleplay', 'tvshow'].indexOf(item.doctype) > -1"
            :data-list="item.results"
            :type="item.doctype"
            :get-uigs="getUigs"
            :show-loading="!loadingFinished"
          />
          <ShortVideo
            v-else
            :short-video="item.results"
            :get-uigs="getUigs"
            :get-uigs-play-info="getShortVideoPlayInfo"
            :show-loading="!loadingFinished"
            :search-data="searchData"
            :star-tab="starTab"
          />
        </div>
      </div>
      <Gotop />
    </div>
    <div v-else>
      <NoResult />
      <Gotop />
    </div>
    <div
      style="display: none"
      v-html="'<!--star-->'"
    />
  </div>
</template>

<script>
import * as types from '@types';
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';

import Gotop from '../common/components/Gotop.vue';
import { getScrollParams, getSpver } from '../common/js/util';
import pageExpose from '../common/mixins/pageExpose';
import ClassList from './components/ClassList.vue';
import NoResult from './components/NoResult.vue';
import ShortVideo from './components/ShortVideo.vue';
import StarHead from './components/StarHead.vue';

export default {
  components: {
    StarHead,
    ClassList,
    ShortVideo,
    Gotop,
    NoResult,
  },
  mixins: [pageExpose],
  data() {
    return {
      ipp: 15,
      loading: false,
    };
  },
  computed: {
    ...mapState('star', ['starEntity', 'searchData', 'starTab', 'shortVideo', 'session']),
    ...mapState('common', ['loadingFinished']),
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || 0;
    },
  },
  watch: {
    $route(to) {
      if (!to.query.starTab) {
        to.query.starTab = 'video'; // eslint-disable-line no-param-reassign
      }
      const { starTab } = to.query;
      this[types.UPDATE_STAR_TAB](starTab);
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('star/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_SEARCH_STAR_ERROR]', err));
  },
  mounted() {
    this[types.UPDATE_LOADING_FINISHED](true);
    window.addEventListener('scroll', this.debounce());
    const navbox = document.querySelector('.star-top-nav-box .cur');
    if (navbox) {
      navbox.scrollIntoView({ block: 'end', inline: 'center' });
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    ...mapMutations('star', [
      types.UPDATE_STAR_TAB,
      types.UPDATE_STAR_ENTITY,
    ]),
    ...mapMutations('common', [types.UPDATE_LOADING_FINISHED]),
    async getWorkData() {
      const self = this;
      if (self.loadingFinished) {
        self[types.UPDATE_LOADING_FINISHED](false);
      }
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const screenH = window.screen.height;
      const H = 350;
      if (
        scrollHeight - scrollTop - screenH > H
        || !self.starEntity
        || !self.starEntity.entity
        || !self.starEntity.entity.length
      ) {
        return;
      }
      const workList = self.starEntity.entity;
      for (let i = 0; i < workList.length; i += 1) {
        const workItem = workList[i];
        if (workItem.doctype === self.starTab || !self.starTab) {
          await self.getStarEntityList(workItem);
        }
      }
    },
    getShortVideoPlayInfo({ item }) {
      if (item.itemUrl) {
        if (item.dockey && item.dockey.indexOf('singleshow') > -1) {
          return `play_type=lvideo&play_url=${encodeURIComponent(item.itemUrl)}&play_site=${item.site_d}`;
        }
        return `play_type=video&play_url=${encodeURIComponent(item.itemUrl)}&play_site=${item.site_d}`;
      }
    },
    async getStarEntityList(item) {
      const itemCpy = item;
      if (!itemCpy || !itemCpy.results || this.loading) return;
      const self = this;
      const starName = encodeURIComponent(self.searchData.star);
      const start = itemCpy.results.length;
      const totalLen = parseInt(itemCpy.totalitems, 10);
      if (start >= totalLen || this.loadingFinished) {
        self[types.UPDATE_LOADING_FINISHED](true);
        return;
      }
      this.loading = true;
      let res = [];
      try {
        const url = `/napi/video/element?req=star_entity&ie=utf8&ipad=1&star=${
          starName
        }&entity_doctype_list=${
          itemCpy.doctype
        }:${itemCpy.role}:${start}:${self.ipp}${self.spver ? '&spver=1' : ''}`;
        res = await axios(url);
        res = res.data;
        if (res && res.data && res.data.entity && res.data.entity.length > 0) {
          const tempRes = res.data.entity[0].results;
          itemCpy.results = itemCpy.results.concat(tempRes);
          const page = Math.ceil(itemCpy.results.length / 15);
          this.sendScrollPv(page);
          await this[types.UPDATE_STAR_ENTITY](self.starEntity);
        } else {
          self[types.UPDATE_LOADING_FINISHED](true);
        }
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
        self[types.UPDATE_LOADING_FINISHED](true);
      }
      this.loading = false;
    },
    getUigs({ item }) {
      let type = '';
      if (item.dockey && item.dockey.indexOf('_') > 0) {
        [type] = item.dockey.split('_');
      }
      return `out_${type}`;
    },
    debounce() {
      // 防抖or节流函数
      let timer = null;
      const self = this;
      return function () {
        if (!timer) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            self.getWorkData();
            timer = null;
          }, 200);
        }
      };
    },
    sendScrollPv(page, suuid = '') {
      const opts = getScrollParams({
        scrollParams: JSON.stringify({ addition: true, pn: page }),
      });
      opts.suuid = suuid;
      this.$uigs.send(opts);
    },
  },
};
</script>
